// extracted by mini-css-extract-plugin
export default {"credits":"Credits_credits__FVD2z","copyright":"Credits_copyright__s6Tbl","social":"Credits_social__YnjqJ"};